import React from "react";

// A tiny inline trend line with no axes/labels — meant to sit inside a stat tile.
export default function Sparkline({ data, color = "#1a73e8", width = 72, height = 26 }) {
  if (!data || data.length < 2) return null;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const points = data.map((v, i) => [i * stepX, height - ((v - min) / range) * height]);
  const path = points.map((p) => p.join(",")).join(" ");
  const last = points[points.length - 1];

  return (
    <svg width={width} height={height} className="shrink-0 overflow-visible">
      <polyline points={path} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.85" />
      <circle cx={last[0]} cy={last[1]} r="2" fill={color} />
    </svg>
  );
}
